import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiLoadingSparkle = (props) => /* @__PURE__ */ _jsxs("svg", {
	"aria-hidden": "true",
	"aria-label": "ai-loading-sparkle",
	viewBox: "0 0 40 12",
	fill: "none",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 3C6.07971 3 6.17151 3.04835 6.19137 3.15406C6.32382 3.86038 6.60951 4.4588 7.04815 4.91328C7.48646 5.36741 8.0816 5.68214 8.84058 5.81498C9.05338 5.85208 9.0529 6.14789 8.84058 6.18502C8.0816 6.31786 7.48646 6.63259 7.04815 7.08672C6.60951 7.5412 6.32383 8.13958 6.19138 8.84591C6.17151 8.95162 6.07971 9 6 9C5.92029 9 5.82849 8.95165 5.80863 8.84594C5.67618 8.13962 5.39049 7.54122 4.95185 7.08676C4.51354 6.63264 3.9184 6.31791 3.15941 6.18502C2.94662 6.14792 2.9471 5.85211 3.15942 5.81498C3.9184 5.68214 4.51354 5.36741 4.95185 4.91328C5.39049 4.4588 5.67617 3.86042 5.80862 3.15409C5.82849 3.04839 5.92029 3 6 3Z",
			fill: "#8C17D2",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "opacity",
				values: "0.4; 1; 0.4",
				keyTimes: "0; 0.5; 1",
				dur: "1.5s",
				repeatCount: "indefinite",
				begin: "0s"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 2C20.1063 2 20.2287 2.06447 20.2552 2.20541C20.4318 3.14718 20.8127 3.94507 21.3975 4.55103C21.9819 5.15655 22.7755 5.57618 23.7874 5.7533C24.0712 5.80277 24.0705 6.19718 23.7874 6.2467C22.7755 6.42382 21.9819 6.84345 21.3975 7.44897C20.8127 8.05493 20.4318 8.85278 20.2552 9.79455C20.2287 9.93549 20.1063 10 20 10C19.8937 10 19.7713 9.93553 19.7448 9.79459C19.5682 8.85282 19.1873 8.05496 18.6025 7.44902C18.0181 6.84352 17.2245 6.42389 16.2126 6.24669C15.9288 6.19722 15.9295 5.80282 16.2126 5.7533C17.2245 5.57618 18.0181 5.15655 18.6025 4.55103C19.1873 3.94507 19.5682 3.14722 19.7448 2.20545C19.7713 2.06451 19.8937 2 20 2Z",
			fill: "#8C17D2",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "opacity",
				values: "0.6; 1; 0.6",
				keyTimes: "0; 0.5; 1",
				dur: "1.5s",
				repeatCount: "indefinite",
				begin: "0.3s"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M34 0C34.1594 0 34.343 0.0967055 34.3827 0.308112C34.6476 1.72077 35.219 2.91761 36.0963 3.82655C36.9729 4.73482 38.1632 5.36427 39.6812 5.62996C40.1068 5.70416 40.1058 6.29577 39.6812 6.37004C38.1632 6.63573 36.9729 7.26518 36.0963 8.17345C35.219 9.08239 34.6477 10.2792 34.3828 11.6918C34.343 11.9032 34.1594 12 34 12C33.8406 12 33.657 11.9033 33.6173 11.6919C33.3524 10.2792 32.781 9.08245 31.9037 8.17353C31.0271 7.26528 29.8368 6.63583 28.3188 6.37004C27.8932 6.29584 27.8942 5.70423 28.3188 5.62996C29.8368 5.36427 31.0271 4.73482 31.9037 3.82655C32.781 2.91761 33.3523 1.72083 33.6172 0.308177C33.657 0.0967702 33.8406 0 34 0Z",
			fill: "#8C17D2",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "opacity",
				values: "1; 0.6; 1",
				keyTimes: "0; 0.5; 1",
				dur: "1.5s",
				repeatCount: "indefinite",
				begin: "0.6s"
			})
		})
	]
});
export default SvgAiLoadingSparkle;
